import { select, put, call, all } from "redux-saga/effects"
import { delay } from "redux-saga"
import { path } from "ramda"
import { push } from "react-router-redux"
import numeral from "numeral"
import qs from "query-string"
import questionMap from "../utils/map-question-names-to-fields"
import Raven from "../utils/raven"

/**
 * Selectors
 */
const selectNewMortgageWizard = state =>
  path(["form", "newMortgageWizard", "values"], state)
const selectRenewalMortgageWizard = state =>
  path(["form", "renewalMortgageWizard", "values"], state)

export function* onSubmitNew(action) {
  const form = yield select(selectNewMortgageWizard)
  const profile = form.contact
  try {
    yield all([
      call(window.analytics.track, "Completed Lead Form"),
      call(window.analytics.identify, profile.email, {
        name: profile.fullname,
        lastName: profile.fullname,
        email: profile.email,
        phone: profile.areaCode + profile.number,
        locale: window.navigator && window.navigator.language,
        channel: "browser",
        cfProvince: profile.province,
        cfMortgageType: "Reverse",
        cfDeclaredGoal: form.goal,
        cfPurpose: form.purpose,
        cfPropertyValue: form.propertyValue,
        cfTransactionPeriod: form.timing
      })
    ])
    const pathname = localStorage.currentLocale === "fr-CA" ? "/taux" : "/rates"
    yield put(
      push({
        pathname,
        search: `?${qs.stringify({
          cfPropertyValue: numeral(form.propertyValue).value(),
          cfMortgageType: "new-mortgage"
        })}`
      })
    )
  } catch (error) {
    Raven.captureException(error, { extra: { redux: { action } } })
  }
}

export function* onSubmitRenewal(action) {
  const form = yield select(selectRenewalMortgageWizard)
  const profile = form.five
  try {
    yield all([
      call(window.analytics.track, "Completed Lead Form"),
      call(window.analytics.identify, profile.email, {
        name: profile.fullname,
        lastName: profile.fullname,
        email: profile.email,
        phone: profile.areaCode + profile.number,
        locale: window.navigator && window.navigator.language,
        context: {
          userAgent: window.navigator && window.navigator.userAgent
        },
        channel: "browser",
        cfProvince: profile.province,
        cfMortgageType: "Mortgage Renewal",
        cfPurpose: form.one,
        cfBalance: form.two,
        cfDownPayment: form.three,
        cfTransactionPeriod: form.four
      })
    ])
    const pathname = localStorage.currentLocale === "fr-CA" ? "/taux" : "/rates"
    yield put(
      push({
        pathname,
        search: `?${qs.stringify({
          cfLoanAmount: numeral(form.two).value(),
          cfMortgageType: "renewal",
          cfDownPayment: form.three,
          cfTransactionPeriod: form.four
        })}`
      })
    )
  } catch (error) {
    Raven.captureException(error, { extra: { redux: { action } } })
  }
}



// WEBPACK FOOTER //
// ./src/sagas/wizard.sagas.js